import { Component, ViewChild, ViewContainerRef } from "@angular/core";
import {
  ColDef,
  GridApi,
  GridOptions,
  IDatasource,
  IGetRowsParams,
  RowNode,
} from "ag-grid-community";
import { CalendarDatepickerComponent } from "../../../calendar/calendar-datepicker.component";
import { AgGridEvrideoCustomLoadingOverlayComponent } from "../../../common/ag-grid-evrideo/ag-grid-evrideo-custom-loading-overlay/ag-grid-evrideo-custom-loading-overlay.component";
import { Moment } from "moment";
import { AgGridEvrideoCheckboxCellComponent } from "../../../common/ag-grid-evrideo/ag-grid-evrideo-checkbox-cell/ag-grid-evrideo-checkbox-cell.component";
import { AgGridEvrideoSelectAllHeaderColumnComponent } from "../../../common/ag-grid-evrideo/ag-grid-evrideo-select-all-header-column/ag-grid-evrideo-select-all-header-column.component";
import { ContentControlAssetsHubEditCellComponent } from "./content-control-assets-hub-edit-cell/content-control-assets-hub-edit-cell.component";
import { AgGridEvrideoCheckedIconCellComponent } from "../../../common/ag-grid-evrideo/ag-grid-evrideo-checked-icon-cell/ag-grid-evrideo-checked-icon-cell.component";
import { IContentControlManager } from 'app/js/src/domain/content-control/manager';
import { ContentControlledItemsSpecifications } from 'app/js/src/domain/content-control/specifications';
import moment from "moment";
import { AgGridEvrideoVideoNameCellComponent } from "../../../common/ag-grid-evrideo/ag-grid-evrideo-video-name-cell/ag-grid-evrideo-video-name-cell.component";
import { AgGridFormatDateTime } from "app/js/src/domain/common/ui-utils";
import { IContentControlRepository } from 'app/js/src/domain/content-control/repository';
import {
  AIVideoAnalyzeConfig,
  IAIObjectDetectionClass,
  ScheduleAiJobRequest,
  ScheduleAiJobResponse,
  ScheduleAiJobsRequest,
} from 'app/js/src/domain/content-control/ai';
import { ContentControlItem } from 'app/js/src/domain/content-control/item';
import { IEvrideoDialogService } from 'app/js/src/domain/common/i-evrideo-dialog-service';
import { IMediaTranscoderRepository } from 'app/js/src/domain/media-transcoder/media-transcoder.repository';
import { ETranscodingJobStatus } from 'app/js/src/domain/media-transcoder/transcoder-job';
import { AgGridEvrideoStateIconComponent } from '../../../common/ag-grid-evrideo/ag-grid-evrideo-state-icon/ag-grid-evrideo-state-icon.component';
import { IAiJobsRepository } from 'app/js/src/domain/content-control/ai-jobs';
import { TenantSettingsRepository } from "app/js/src/domain/tenant-settings-repository";
import {
  ICommonUtilInterface
} from "../../../../domain/common/common-util.interface";

@Component({
  selector: "evrideo-content-control-assets-hub",
  templateUrl: "./content-control-assets-hub.component.html",
  styleUrls: ["./content-control-assets-hub.component.scss"],
})
export class ContentControlAssetsHubComponent {
  private static JOB_REQUEST_DIALOG_TITLE = "AI JOB Request";
  private static DOWNLOAD_DIALOG_TITLE = "Download items";
  private static RENDER_DIALOG_TITLE = "Render items";

  @ViewChild(CalendarDatepickerComponent)
  datePicker: CalendarDatepickerComponent;
  public searchTerm: string = "";
  public filteringDateString: string;
  private filteringDate: Moment;
  public selectedTableItemsCount = 0;
  public pageSize = 100;
  public gridOptions: GridOptions;
  public overlayNoRowsTemplate = `<div style='display:flex;flex-direction: column; align-items: center;'><svg xmlns="http://www.w3.org/2000/svg" width="180" height="181" viewBox="0 0 180 181" fill="none">
  <mask id="mask0_4367_2038" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="16" y="19" width="148" height="147">
    <circle cx="90" cy="92.3728" r="73.2051" transform="rotate(-60 90 92.3728)" fill="#ED6C02"/>
    <circle cx="90" cy="92.3728" r="73.2051" transform="rotate(-60 90 92.3728)" fill="#EDF7FE"/>
  </mask>
  <g mask="url(#mask0_4367_2038)">
    <circle cx="90" cy="92.3728" r="73.2051" fill="#EDF7FE"/>
    <path d="M104.457 111.651L107.612 114.602L160.368 163.997C160.478 164.101 160.652 164.094 160.755 163.984L164.24 160.26C164.344 160.15 164.337 159.976 164.227 159.874L111.557 110.561L108.415 107.619C107.225 109.106 105.896 110.453 104.457 111.651Z" fill="#A2E0FD"/>
    <path d="M98.7202 59.7289C115.379 66.5778 123.33 85.6342 116.482 102.292C115.223 105.355 113.551 108.124 111.557 110.56C110.353 112.033 109.032 113.382 107.612 114.602C98.6023 122.354 85.6651 124.882 73.9197 120.054C57.2605 113.205 49.3087 94.1503 56.1575 77.4911C63.0057 60.8337 82.061 52.88 98.7202 59.7289Z" fill="#CBEEFE"/>
    <path d="M80.3532 66.1114C84.1374 67.6671 85.9435 71.9959 84.3879 75.7797C84.1019 76.4754 83.7221 77.1045 83.2691 77.658C82.9956 77.9925 82.6956 78.2989 82.373 78.5761C80.3264 80.337 77.3876 80.9113 74.7196 79.8144C70.9354 78.2587 69.1291 73.9304 70.6848 70.1461C72.2404 66.3623 76.5689 64.5556 80.3532 66.1114Z" fill="white"/>
    <path d="M98.7202 59.7289C115.379 66.5778 123.33 85.6342 116.482 102.292C115.223 105.355 113.551 108.124 111.557 110.56C110.353 112.033 109.032 113.382 107.612 114.602C98.6023 122.354 85.6651 124.882 73.9197 120.054C57.2605 113.205 49.3087 94.1503 56.1575 77.4911C63.0057 60.8337 82.061 52.88 98.7202 59.7289ZM75.5509 116.086C85.6001 120.217 96.651 118.147 104.457 111.651C105.896 110.453 107.225 109.106 108.415 107.619C110.07 105.558 111.459 103.228 112.514 100.66C118.462 86.1944 111.557 69.6446 97.0889 63.6968C82.6212 57.7488 66.0726 64.6565 60.1254 79.1223C54.1776 93.59 61.0832 110.138 75.5509 116.086Z" fill="#A2E0FD"/>
    <path d="M116.097 124.939L159.941 164.784C160.468 165.262 161.282 165.223 161.76 164.697L165.665 160.4C166.143 159.874 166.104 159.06 165.578 158.581L121.733 118.737C121.207 118.259 120.393 118.297 119.914 118.824L116.01 123.12C115.531 123.647 115.57 124.461 116.097 124.939Z" fill="#29AAE5"/>
  </g>
  <path d="M23.5566 67.3785C29.875 65.2083 34.0482 61.0178 36.2165 54.709C38.3676 61.0312 42.5599 65.1986 48.8379 67.3208C45.9808 68.6272 43.1872 69.9047 40.9726 72.1289C38.762 74.3491 37.4613 77.1197 36.1703 80.0191C34.0405 73.745 29.8904 69.518 23.5566 67.3785Z" fill="#29AAE5"/>
  <path d="M74.9082 54.7175C78.6792 53.4207 81.1708 50.9215 82.4656 47.1543C83.749 50.9272 86.2521 53.4169 90 54.6829C88.2954 55.4621 86.6272 56.2259 85.3055 57.5535C83.9856 58.8791 83.2102 60.5337 82.4387 62.2634C81.167 58.5193 78.6908 55.995 74.9082 54.7175Z" fill="#29AAE5"/>
  <path d="M56.521 22.0799C60.9577 20.5541 63.888 17.6124 65.4118 13.1814C66.9221 17.622 69.8658 20.5484 74.2756 22.0375C72.2689 22.9553 70.3064 23.8519 68.7518 25.4142C67.1992 26.9745 66.2853 28.9197 65.3791 30.9553C63.8841 26.5512 60.9693 23.5825 56.521 22.0799Z" fill="#29AAE5"/>
</svg><h2>Your list is empty. try the search bar to load files.</h2></div>`;
  gridApi: GridApi;
  gridColumnApi: any;
  columnDefs: ColDef[] = [
    {
      resizable: false,
      pinned: "left",
      maxWidth: 60,

      cellRenderer: AgGridEvrideoCheckboxCellComponent,
      headerComponent: AgGridEvrideoSelectAllHeaderColumnComponent,
      cellStyle: { padding: 0 },
    },
    {
      headerName: "MediaID",
      field: "mediaId",
      hide: true,
    },
    {
      headerName: "ID",
      field: "mediaUniqueId",
    },
    {
      headerName: "Name",
      cellRenderer: AgGridEvrideoVideoNameCellComponent,
      cellRendererParams: {
        videoName: (data) => data?.mediaName || "",
        videoThumb: (data) => data?.snapshotUrl || "",
      },
    },
    {
      headerName: "AI",
      maxWidth: 86,
      resizable: false,
      cellRenderer: AgGridEvrideoStateIconComponent,
      cellRendererParams: (params) => {
        return (
          params.context.liveUpdatedRows[`${params.data?.mediaId}AI`] || {
            isChecked: params.data?.isAI || false,
            progress: -1,
            renderType: "",
          }
        );
      },
    },
    {
      headerName: "Edited",
      maxWidth: 86,
      resizable: false,
      cellRenderer: AgGridEvrideoStateIconComponent,
      cellRendererParams: (params) => {
        return (
          params.context.liveUpdatedRows[`${params.data?.mediaId}Edited`] || {
            isChecked: params.data?.isEdited || false,
            progress: 0,
            renderType: "",
          }
        );
      },
    },
    {
      headerName: "Rendered",
      maxWidth: 120,
      resizable: false,
      cellRenderer: AgGridEvrideoStateIconComponent,
      cellRendererParams: (params) => {
        return (
          params.context.liveUpdatedRows[`${params.data?.mediaId}Rendered`] || {
            isChecked: params.data?.isRendered || false,
            progress: -1,
            renderType: "",
            status: "",
          }
        );
      },
    },
    {
      headerName: "Uploaded date",
      field: "uploadedDate",
      cellRenderer: AgGridFormatDateTime.bind(this),
    },
    {
      headerName: "",
      maxWidth: 60,
      resizable: false,
      pinned: "right",

      cellRenderer: ContentControlAssetsHubEditCellComponent,
    },
  ];
  dataSource: IDatasource = {
    rowCount: undefined,
    getRows: async (params: IGetRowsParams) => {
      // At this point in your code, you would call the server.
      // To make the demo look real, wait for 500ms before returning
      let rowCount = params.startRow;
      try {
        let specifications = {
          term: this.searchTerm,
          dateFrom: this.filteringDate.format("YYYY-MM-DD HH:mm"),
          limit: params.context.componentParent.pageSize,
          offset: params.startRow,
        } as ContentControlledItemsSpecifications;
        params.context.componentParent.manuallyHideOverlay();
        params.context.componentParent.manuallyShowLoadingOverlay();
        let result = await this._manager.searchItems(specifications);
        rowCount = params.startRow;
        if (result.length === 0) {
          // no results
          rowCount = 0;
        } else if (result.length == params.context.componentParent.pageSize) {
          // has next page
          rowCount += params.context.componentParent.pageSize + 1;
        } else {
          // last page
          rowCount += result.length;
        }
        params.successCallback(result, rowCount);
        //params.successCallback([], 1);
      } catch {
      } finally {
        params.context.componentParent.manuallyHideOverlay();
        if (params?.context?.componentParent?.gridApi) {
          if (rowCount === 0) {
            setTimeout(() =>
              params.context.componentParent.gridApi?.showNoRowsOverlay(),
            );
          } else {
            await params.context.componentParent.updateCellRendererParams();
            if (this.updateCellRendererParamsInterval){
              window.clearInterval(this.updateCellRendererParamsInterval);
            }
            this.updateCellRendererParamsInterval = window.setInterval(
              () => params.context.componentParent.updateCellRendererParams(),
              5000,
            );
          }
        }
      }
    },
  };
  updateCellRendererParamsInterval: number;

  constructor(
    private _manager: IContentControlManager,
    private _dialogService: IEvrideoDialogService,
    private viewContainerRef: ViewContainerRef,
    private _tenantSettingsRepository: TenantSettingsRepository,
    private _mediaTranscoderRepository: IMediaTranscoderRepository,
    private _contentControlRepository: IContentControlRepository,
    private _aiJobsRepository: IAiJobsRepository,
    private _commonUtils: ICommonUtilInterface
  ) {}

  ngOnInit() {
    //this._aiJobsRepository.get().then(aiJobs => console.log('ContentControlAssetsHubComponent->ngOnInit->aiJobs', aiJobs));
    this.resetFiltereDate();
    this.gridOptions = <GridOptions>{
      context: {
        componentParent: this,
        liveUpdatedRows: {} as { [key: string]: any },
      },
      rowModelType: "infinite",
      columnDefs: this.columnDefs,
      defaultColDef: {
        resizable: true,
        lockPosition: true,
        sortable: false,
        width: 155,
        flex: 1,
        cellClass: "ag-grid-evrideo-default-cell-class",
      } as ColDef,
      rowHeight: 44,
      suppressHorizontalScroll: true,
      suppressRowClickSelection: true,
      animateRows: true,
      paginationAutoPageSize: false,
      paginationPageSize: this.pageSize,
      pagination: true,
      enableCellTextSelection: true,
      rowSelection: "multiple",
      getRowHeight: (e) => {
        let height = 44;
        return height;
      },
      datasource: this.dataSource,
      maxConcurrentDatasourceRequests: 2,
      loadingOverlayComponent: AgGridEvrideoCustomLoadingOverlayComponent,
      overlayNoRowsTemplate: this.overlayNoRowsTemplate,
    };
  }
  ngOnDestroy() {
    if (this.updateCellRendererParamsInterval) {
      console.log('ContentControlAssetsHubComponent->ngOnDestroy->clearing interval');
      window.clearInterval(this.updateCellRendererParamsInterval);
    }
  }
  doSearch(): void {
    this.gridApi.setGridOption("datasource", this.dataSource);
    this.manuallyShowLoadingOverlay();
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
  }
  onSelectionChanged(event) {
    var nodes = event.api.getSelectedNodes();
    this.selectedTableItemsCount = nodes.length;
  }
  setPageSize(pageSize: number) {
    this.pageSize = pageSize;
    if (this.gridApi) {
      this.gridApi.setGridOption("paginationPageSize", this.pageSize);
      this.gridApi.setGridOption("cacheBlockSize", this.pageSize);
      this.gridApi.purgeInfiniteCache();
      this.doSearch();
    }
  }
  manuallyShowLoadingOverlay() {
    if (this.gridApi) {
      setTimeout(() => this.gridApi.showLoadingOverlay());
    }
  }
  manuallyHideOverlay() {
    if (this.gridApi) {
      setTimeout(() => this.gridApi.hideOverlay());
    }
  }
  showDatepicker(): void {
    this.datePicker.show();
  }
  hideDatepicker() {
    this.resetFiltereDate();
    this.datePicker.hide();
  }
  resetFiltereDate() {
    this.filteringDate = moment("2000-01-01T00:00:00Z");
    this.filteringDateString = "Any time";
  }

  onDatepickerApply(newDate: Moment) {
    this.hideDatepicker();
    // this.activeView
    this.filteringDate = newDate;
    this.filteringDateString = newDate.format("YYYY-MM-DD HH:mm");
  }
  onDatepickerClickedOutside() {
    this.datePicker.hide();
  }
  onKeypressEvent(event: KeyboardEvent) {
    if (event.key == "Enter") {
      setTimeout(() => {
        this.doSearch();
      }, 100);
    }
  }

  private async updateCellRendererParams() {
    if (!this.gridApi) return;
    const jobs = await this._mediaTranscoderRepository.getJobs([
      ETranscodingJobStatus.Active,
    ]);
    console.log('ContentControlAssetsHubComponent->updateCellRendererParams->jobs');
    const rowsToUpdate: Set<RowNode> = new Set<RowNode>();
    this.gridApi.forEachNode((rowNode: RowNode) => {
      this.columnDefs.forEach((colDef) => {
        if (colDef.headerName && colDef.cellRenderer) {
          let cellRendererParams = undefined;
          switch (colDef.headerName) {
            case "AI":
              cellRendererParams = {
                // DOTO: get progress from ai controller
                // rowsToUpdate.add(rowNode);
                // rowNode.data?.aiJobUid ? false : rowNode.data?.isAI || false,
                isChecked: rowNode.data?.isAI || false,
                //isChecked: false,
                renderType: "", // spinning
                progress: 0, // 33,66,100
                status: "in progress", // "waiting in queue", "in progress", "completed"
              };
              if (rowNode.data && rowNode.data.hasAiJobsRunning) {
                cellRendererParams.renderType = 'spinning';
                cellRendererParams.isChecked = false;
                cellRendererParams.progress = 66;
              }

              break;
            case "Rendered":
              const job = jobs.find(
                (j) => j.id == rowNode.data?.mediaTranscoderJobUid,
              );
              let progress = -1;
              let status = "";
              if (
                job &&
                (!job.actualStartTime || job.actualStartTime.isValid())
              ) {
                progress = 33;
                status = "Render in queue";
              }
              if (
                job &&
                job.actualStartTime &&
                job.actualStartTime.isValid() &&
                (!job.actualEndTime || !job.actualEndTime.isValid())
              ) {
                progress = 66;
                status = "Render is in progress";
              }
              cellRendererParams = {
                isChecked:
                  progress > -1 ? false : rowNode.data?.isRendered || false,
                renderType: "spinning",
                progress: progress,
                status: status,
              };
              break;
            case "Edited":
              cellRendererParams = {
                isChecked: rowNode.data?.isEdited || false,
                renderType: "",
                progress: 0,
                status: "",
              };
              break;
          }
          if (cellRendererParams) {
            rowsToUpdate.add(rowNode);
            this.gridOptions.context.liveUpdatedRows[
              `${rowNode.data.mediaId}${colDef.headerName}`
            ] = cellRendererParams;
          }
        }
      });
    });
    if (rowsToUpdate.size > 0) {
      const nodes = Array.from(rowsToUpdate);
      this.gridApi.refreshCells({
        force: true,
        rowNodes: nodes,
      });
    }
  }

  private getSelectedItems(): ContentControlItem[] {
    return this.gridApi
      .getSelectedNodes()
      .map((n) => n.data as ContentControlItem);
  }
  async onRenderButtonClicked() {
    const selectedControlItems = this.getSelectedItems();
    if (selectedControlItems && selectedControlItems.length > 0) {
      const result = await this._manager.renderItems(selectedControlItems);

      if (result.success.length > 0) {
        const nodes = this.gridApi.getSelectedNodes();
        nodes.forEach((x) => {
          x.data.mediaTranscoderJobUid = selectedControlItems.find(
            (s) => s.mediaId == x.data.mediaId,
          )?.mediaTranscoderJobUid;
        });
        this.updateCellRendererParams();
        await this._dialogService.openDialog(this.viewContainerRef, {
          type: "info",
          title: ContentControlAssetsHubComponent.RENDER_DIALOG_TITLE,
          content: result.success.join("<br>"),
          timeout: 5000,
        });
      }
      if (result.errors.length > 0) {
        this._dialogService.openDialog(this.viewContainerRef, {
          type: "error",
          title: ContentControlAssetsHubComponent.RENDER_DIALOG_TITLE,
          content: result.errors.join("<br>"),
          timeout: 5000,
        });
      }
    }
  }
  async onDownloadButtonClicked() {
    const selectedControlItems = this.getSelectedItems();
    if (selectedControlItems && selectedControlItems.length > 0) {
      const renderedItems = selectedControlItems.filter(
        (i) => i.isRendered === true,
      );
      if (renderedItems && renderedItems.length > 0) {
        if (renderedItems.length != selectedControlItems.length) {
          const result = await this._dialogService.openDialog(
            this.viewContainerRef,
            {
              title: ContentControlAssetsHubComponent.DOWNLOAD_DIALOG_TITLE,
              type: "warning",
              content:
                "It appears that some items have not been rendered yet.<br> Would you like to proceed with what has already been rendered?",
              confirmButtonText: "Yes",
              cancelButtonText: "No",
            },
          );
          if (result) {
            await this.downloadRenderedItems(renderedItems);
          }
        } else {
          await this.downloadRenderedItems(renderedItems);
        }
      } else {
        await this._dialogService.openDialog(this.viewContainerRef, {
          title: ContentControlAssetsHubComponent.DOWNLOAD_DIALOG_TITLE,
          type: "info",
          content:
            "It appears that none of the selected items have not been rendered yet.",
          timeout: 3000,
        });
      }
    }
  }
  async downloadRenderedItems(items: ContentControlItem[]) {
    const result = await this._manager.downloadRenderedVideo(items);
    if (result.success.length > 0) {
      result.success.forEach((downloadItem) => {
        setTimeout(() => {
          const link = document.createElement("a");
          link.href = downloadItem.url;
          link.setAttribute("target", "_blank");
          link.download = downloadItem.name;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }, 1);
      });
    }
    if (result.errors.length > 0) {
      this._dialogService.openDialog(this.viewContainerRef, {
        title: ContentControlAssetsHubComponent.DOWNLOAD_DIALOG_TITLE,
        type: "error",
        content: result.errors.join("<br>"),
        timeout: 5000,
      });
    }
  }
  async onAIButtonClicked() {
    const selectedControlItems = this.getSelectedItems();
    if (selectedControlItems && selectedControlItems.length > 0) {
      const tenantSettings = await this._tenantSettingsRepository.getTenantSettings();
      let aiDetectionsSettings = [];
      if (tenantSettings.ContentControlAIdetectionsSettings){
        aiDetectionsSettings = tenantSettings.ContentControlAIdetectionsSettings;
      }
      if (aiDetectionsSettings.length == 0) {
        this._dialogService.openDialog(this.viewContainerRef, {
          title: ContentControlAssetsHubComponent.JOB_REQUEST_DIALOG_TITLE,
          content:
            "No AI detections settings found.<br> Please contact support.",
          type: "error",
          timeout: 2000,
        });
      } else {
        const enabledRequiredClasses: IAIObjectDetectionClass[] = aiDetectionsSettings
          .filter((x) => x.isEnabled)
          .map((x) => x.requiredClass);
        if (enabledRequiredClasses.length == 0) {
          this._dialogService.openDialog(this.viewContainerRef, {
            title: ContentControlAssetsHubComponent.JOB_REQUEST_DIALOG_TITLE,
            content:
              "No AI detections are enabled.<br> Please contact support.",
            type: "error",
            timeout: 2000,
          });
        } else {
          const scheduleAiJobsRequest = new ScheduleAiJobsRequest();

          const itemsByJobUid = {};

          for (const contentControlItem of selectedControlItems) {
            const createAiJobRequest = ScheduleAiJobRequest.createWithDetectionClasses(
              this._commonUtils.generateGuid(),
              contentControlItem.transcodingVideoUrl,
              contentControlItem.mediaId,
              enabledRequiredClasses
            );
            itemsByJobUid[createAiJobRequest.Guid] = contentControlItem;
            scheduleAiJobsRequest.AiJobs.push(createAiJobRequest);
          }
          console.log(
            `content-control-assets-hub->scheduleAiJobsRequest`,
            scheduleAiJobsRequest,
          );
          this._dialogService.openDialogWithLoading(
            this.viewContainerRef,
            {
              title: ContentControlAssetsHubComponent.JOB_REQUEST_DIALOG_TITLE,
              loadingContent: "Creating AI Job requests",
            },
            this._contentControlRepository.scheduleAiJob(scheduleAiJobsRequest),
            (results: ScheduleAiJobResponse[]) => {
              const responses = [];
              responses.push(
                `-------------------AI SCHEDULING-------------------`,
              );
              for (const result of results) {
                const contentControlItem: ContentControlItem =
                  itemsByJobUid[result.jobUid];
                if (result.isSuccess) {
                  contentControlItem.hasAiJobsRunning = true;
                }
                responses.push(
                  `AI job for ${contentControlItem.mediaUniqueId}. Result: ${result.responseMsg}`,
                );
              }
              this.gridApi.refreshCells();
              //params.context.componentParent.updateCellRendererParams();

              responses.push(
                `---------------------------------------------------`,
              );
              console.debug(
                `content-control-assets-hub->results`,
                results,
                responses,
              );
              return {
                type: "success",
                title:
                  ContentControlAssetsHubComponent.JOB_REQUEST_DIALOG_TITLE,
                content: `${selectedControlItems.length} Job${selectedControlItems.length > 1 ? "s" : ""} created successfuly`,
                timeout: 2000,
              };
            },
            (error) => ({
              type: "error",
              title: ContentControlAssetsHubComponent.JOB_REQUEST_DIALOG_TITLE,
              content: "something went wrong",
              confirmButtonText: "Ok",
            }),
          );
        }
      }
    }
  }
}
